<template>
    <v-list-item>
        <v-list-item-content v-if="showLabel">
            <b>{{ column.title }}:</b>
        </v-list-item-content>
        <v-list-item-content class="align-end">
            <template v-if="column.type === 'string'">
                {{ item[column.id] }}
            </template>
            <template v-else-if="column.id === 'birth_date'">
                {{ dateFormat(item[column.id]) }}
            </template>
            <template v-else-if="column.id === 'approved'">
                {{ item[column.id] ? $t('validation.yes') : $t('validation.no') }}
            </template>
            <template v-else-if="column.type === 'switch'">
                {{ item[column.id] ? $t('validation.yes') : $t('validation.no') }}
            </template>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
import {DataRecordsStore} from "@/Store/DataGatherings/DataRecordsStore";
import {mapActions, mapState, mapWritableState} from "pinia/dist/pinia";
export default {
    name: "DataRecordListItemValue",

    props: {
        item: {
            type: Object,
            require: true,
        },

        column: {
            type: Object,
            require: true,
        },

        noLabel: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            loading: false
        }
    },

    methods: {
        //Method that converts and returns milliseconds date to UTC Date format
        dateFormat(isoDateString) {
            const date = new Date(isoDateString);
            const year = date.getUTCFullYear()
            const month = String(date.getUTCMonth() + 1).padStart(2, '0');
            const day = String(date.getUTCDate()).padStart(2, '0');

            return `${year}/${month}/${day}`;
        },

        //Method that update boolean states of dataRecords
        updateSwitches(item) {
            this.setCurrentDataRecord(item);
            this.loading = true
            this.update()
                .catch()
                .then(() => {
                    this.loading = false;
                    this.$emit('save');
                });
        },
        ...mapActions(DataRecordsStore, ['update', 'setCurrentDataRecord',]),
    },

    computed: {
        formattedValue() {

        },

        showLabel() {
            return !this.noLabel;
        },
        ...mapState(DataRecordsStore, ['status']),
    },
}
</script>

<style lang="scss">

.my-custom-switch {
    margin-top: 0;
    margin-left: 4px;

    .v-input__control > .v-messages {
        position: absolute !important;
    }
}

</style>
